import { useRequiredContext } from "@redotech/react-util/context";
import StarsIcon from "@redotech/redo-icons/stars-01.svg";
import StarsFilledIcon from "@redotech/redo-icons/stars-01_filled.svg";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo } from "react";
import { useMatch } from "react-router-dom";

export const ConciergeItems = memo(function ConciergeItems() {
  const team = useRequiredContext(TeamContext);
  const routes = useRequiredContext(MerchantRoutesContext);
  const aiEnabled = !!team?.settings.support?.ai?.enabled;

  const conciergeBaseUrl = routes.legacySupportBaseUrl + "/concierge";
  const anyChildSelected = useMatch(`${conciergeBaseUrl}/*`);

  const children = [
    <RedoSecondaryNavItem
      action={{
        type: "link",
        href: routes.getConciergeSubRoute("conversations"),
      }}
      friendlyName="Conversations"
      hidden={!aiEnabled}
      id="concierge-conversations"
      key="concierge-conversations"
    />,
    <RedoSecondaryNavItem
      action={{ type: "link", href: routes.getConciergeSubRoute("monitoring") }}
      friendlyName="Monitoring"
      hidden={!aiEnabled}
      id="concierge-monitoring"
      key="concierge-monitoring"
    />,
    <RedoSecondaryNavItem
      action={{ type: "link", href: routes.getConciergeSubRoute("testing") }}
      friendlyName="Testing"
      hidden={!aiEnabled}
      id="concierge-testing"
      key="concierge-testing"
    />,
    <RedoSecondaryNavItem
      action={{ type: "link", href: routes.getConciergeSubRoute("knowledge") }}
      friendlyName="Knowledge"
      hidden={!aiEnabled}
      id="concierge-knowledge"
      key="concierge-knowledge"
    />,
  ];

  // Default to conversations if AI is enabled, otherwise the landing page
  const defaultRoute = aiEnabled
    ? routes.getConciergeSubRoute("conversations")
    : routes.getConciergeHref({ enabled: aiEnabled });

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: defaultRoute }}
      anyChildSelected={!!anyChildSelected}
      FilledIcon={StarsFilledIcon}
      friendlyName="AI Agents"
      id="concierge"
      UnfilledIcon={StarsIcon}
    >
      {children}
    </RedoSecondaryNavItem>
  );
});
